import { ReactNode } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import { WorkshopError } from '@/components/Icons'

import messages from './messages'

const StyledErrorContainer = styled.div`
  margin: 3em;
  display: flex;
  flex-direction: column;
`

const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
`

const StyledErrorSubMessage = styled.p`
  margin-left: 40px;
  margin-top: 5px;
  font-size: 0.9em;
`

const StyledErrorIcon = styled.div`
  margin-right: 10px;
`

const StyledErrorHeader = styled.div`
  font-size: 1.5em;
  margin-top: -5px;
`

export interface ErrorMessageProps {
  className?: string
  message?: ReactNode
  subMessage?: ReactNode
}

const InlineErrorMessage = ({ className, message, subMessage }: ErrorMessageProps) => {
  const intl = useIntl()

  return (
    <StyledErrorContainer className={className}>
      <StyledRow>
        <StyledErrorIcon>
          <WorkshopError />
        </StyledErrorIcon>
        <StyledErrorHeader>{message || intl.formatMessage(messages.errorTitle)}</StyledErrorHeader>
      </StyledRow>
      <StyledRow>{subMessage && <StyledErrorSubMessage>{subMessage}</StyledErrorSubMessage>}</StyledRow>
    </StyledErrorContainer>
  )
}

InlineErrorMessage.displayName = 'ErrorMessage'

export default InlineErrorMessage
